module.exports = __webpack_public_path__ + "assets/img/con4-bg.60be6e12.jpg";